// import {data} from "../data/data.ts"
import { formatlongDate,formatTime} from "../../functions/formatDate"
import { useLoaderData, Link } from "react-router-dom"
import { FaArrowCircleUp } from "react-icons/fa";

type Event = {
    id: number;
    title: string,
    date: string,
    time: string,
    location: string,
    cost: string,
    image: string,
    deleted: number,
    url_slug: string
}

export default function Events() {
    const data = useLoaderData();
    let rendered_cards 
    
    if (data.length > 0){
        const today:Date = new Date()
        rendered_cards = data
        .filter((item:Event) => {
            const sevenDaysAgo = new Date(today);
            sevenDaysAgo.setDate(today.getDate() - 7);
            return Date.parse(item.date) > sevenDaysAgo.getTime();
        })
        .sort((a:Event,b:Event)=> Date.parse(a.date)- Date.parse(b.date))
        .map((item:Event) => {
            
            return <>
                <div key={item.id}>
                    <Link to={`${item.url_slug}`} className="event-card-link"  key={item.id}>
                        <div className="event-card"  key={item.id}>
                            <img 
                                className="event-image" 
                                src={`${import.meta.env.VITE_API_URL}/uploads/${item.image}`}
                                width="200px"
                                height="200px"
                             />
                            <h2 className="event-title">{item.title}</h2>
                            <p className="event-time"><span>{formatlongDate(item.date)} </span><span>{formatTime(item.time)}</span></p>
                            <p className="event-location">{item.location.toUpperCase()}</p>
                            <p className="event-cost">{item.cost.toUpperCase()}</p>
                        </div>
                    </Link>

                </div>
            </>
        })
    }
        
    return <>
        <div className="container">
            <div className="events-intro body-text">
                <h2>Community Events</h2>
                <p>Ridgewood Civic hosts a variety of neighborhood events throughout the year, bringing our community together to celebrate and connect. From seasonal celebrations to summer block parties, our events are what make Ridgewood special.</p>
                <p><span className="figtree-bold">Free for All Residents:</span> Thanks to the generosity of our neighbors, most events are free to attend. These gatherings are made possible through annual dues and donations from community members who believe in fostering a connected, vibrant neighborhood.</p>
                <p>Whether you're new to Ridgewood or have been here for years, we encourage you to join us at our next event. It's a great way to meet neighbors, build friendships, and strengthen our community bonds.</p>
            </div>
            <div className="event-card-container">
               {rendered_cards}
            </div>
            <div
                className="btt-btn" 
                onClick={() => window.scrollTo(0, 0)}
            >
                <FaArrowCircleUp />
            </div>
        </div>
    </>
}